import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import { DebugDiv } from '../../../../components/Debug';
import useBtnClickImpression from '../../../../hooks/useBtnClickImpression';
import EventContext from '../../context/EventContext';

const ButtonContainer = styled.div`
  width: 40px;
  height: 60px;
  border: ridge 4px white;
  border-radius: 15%;
  background: rgba(195, 195, 195, 1);
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

const UpArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
  margin-top: 10px;
`;

const LeftArrow = styled.div`
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid white;
  margin-left: 5px;
`;

const RightArrow = styled.div`
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid white;
  margin-right: 5px;
`;

export const MenuDirection = {
  UP: 'UP',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

const MenuTouchableButton = ({ direction, buttonFor }) => {
  let ArrowElem;
  let sizes;
  const { fireEvent } = useContext(EventContext);
  switch (direction) {
    case MenuDirection.UP:
      ArrowElem = UpArrow;
      sizes = {
        width: '40px',
        height: '50px',
      };
      break;
    case MenuDirection.LEFT:
      ArrowElem = LeftArrow;
      sizes = {
        height: '30px',
        width: '50px',
        justifyContent: 'flex-start',
        alignItems: 'center',
      };
      break;
    case MenuDirection.RIGHT:
      ArrowElem = RightArrow;
      sizes = {
        height: '30px',
        width: '50px',
        justifyContent: 'flex-end',
        alignItems: 'center',
      };
      break;
    default:
      ArrowElem = UpArrow;
  }
  const onClick = () => {
    fireEvent(`click-${buttonFor}`, {});
  };
  const btnClickImpression = useBtnClickImpression();
  return (
    <ButtonContainer
      {...btnClickImpression}
      onClick={onClick}
      style={{ ...sizes }}
    >
      <ArrowElem />
      <DebugDiv>{buttonFor}</DebugDiv>
    </ButtonContainer>
  );
};

export default MenuTouchableButton;
